import {
  ArrowRightFromBracketRegularIcon,
  BadgeCheckRegularIcon,
  BadgeCheckSolidIcon,
  CircleCheckSolidIcon,
  DhisLogo,
} from "@elixir/icons";
import { InputField, PrimaryButton, SecondaryButton } from "ui";
import VerifyFlowContainer from "../verify-flow-container";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";
import { OnboardingNavigationStates } from "../../../stores/hpr-hfr-dhis-onboarding/enums";
import { track } from "../../../utils/tracking";
import { HFR_HPR_MIXPANEL_EVENTS } from "@elixir/types";
import usePostCheckHprExist from "../../../apis/axon/hpr/use-post-hpr-exist";

const HprCreatedSuccessfully = () => {
  const createdHprId = useHprHfrOnboardingStore((state) => state.createdHprId);
  const setActiveScreen = useHprHfrOnboardingStore(
    (state) => state.setActiveScreen
  );
  const setHprIdNumber = useHprHfrOnboardingStore(
    (state) => state.setHprIdNumber,
  );
  const transactionId = useHprHfrOnboardingStore(
    (state) => state.transactionId,
  );

  const { mutateAsync: postCheckHprExist, isLoading } = usePostCheckHprExist();

  const handleContinue = async () => {
    if (transactionId) {
      const { success, data, error } = await postCheckHprExist({
        txn_id: transactionId,
      });
      if (success && data) {
        setHprIdNumber(data.hpr_id_number);
        track(HFR_HPR_MIXPANEL_EVENTS.HFR_HPR_EXIST_CHECK_SUCCESS);
      } else {
        track(HFR_HPR_MIXPANEL_EVENTS.HFR_HPR_EXIST_CHECK_FAILURE);
      }
    }

    track(HFR_HPR_MIXPANEL_EVENTS.INIT_CREATE_HFR);
    setActiveScreen(OnboardingNavigationStates.HFR_FORM);
  };

  return (
    <div className="dr-h-full dr-flex dr-flex-col">
      <div className="dr-flex dr-items-center dr-justify-between dr-p-48"></div>
      <div className="dr-w-full dr-flex-1 dr-flex dr-flex-col dr-items-center dr-justify-center dr-space-y-12">
        <BadgeCheckSolidIcon className="dr-w-40 dr-h-40 dr-text-darwin-touch-green-primary" />
        <div className="TouchTitle1Bold dr-text-darwin-touch-neutral-1000 dr-text-center">
          Your HPR ID was created successfully
        </div>
        <div className="dr-flex dr-items-center dr-justify-center dr-rounded-8 dr-bg-darwin-touch-green-bg-light dr-p-12 dr-space-x-12 dr-min-w-310">
          <div className="dr-w-32 dr-h-32 dr-min-w-32 dr-p-6 dr-rounded-full dr-bg-darwin-touch-neutral-0 dr-items-center dr-flex dr-justify-center">
            <DhisLogo />
          </div>
          <div className="HeadlineBold dr-text-darwin-touch-neutral-1000">
            {createdHprId}
          </div>
        </div>
        <PrimaryButton
          extraClass="dr-min-w-200"
          title="Continue"
          onClick={handleContinue}
        />
      </div>
    </div>
  );
};

export default HprCreatedSuccessfully;
